import clsx from 'clsx';
import styles from './ParticipantsTable.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';
const { useState, useEffect } = require('react');
const { useNavigate, useParams } = require('react-router-dom');

const limits = [5, 10, 15, 20];

const ParticipantsTable = ({ participants, page }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [limit, setLimit] = useState(5);

    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + limit;
    const currentItems = participants.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(participants.length / limit);
    const [paginateInfo, setPaginateInfo] = useState({
        currentItems,
        pageCount,
    });

    const handleChangeLimit = (lim) => {
        setLimit(lim);
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * limit) % participants.length;
        setItemOffset(newOffset);

        navigate(`/courses/${id}/participants/?page=${event.selected + 1}`);
    };

    useEffect(() => {
        // Simulate fetching items from another resources.
        // (This could be items from props; or items loaded in a local state
        // from an API endpoint with useEffect and useState)
        var newItemOffset = (page - 1) * limit;
        setItemOffset(newItemOffset);

        const endOffset = newItemOffset + limit;
        const currentItems = participants.slice(newItemOffset, endOffset);
        const pageCount = Math.ceil(participants.length / limit);
        setPaginateInfo({
            currentItems,
            pageCount,
        });
    }, [itemOffset, limit, participants, page]);

    return (
        <div className={clsx(styles.participantsBody)}>
            {paginateInfo.currentItems.map((participant) => {
                return (
                    <div className={clsx(styles.participantsTRow)}>
                        <div className={clsx('col-5', styles.participantsTD)}>{participant.name}</div>
                        <div className={clsx('col-2', styles.participantsTD)}>{participant.student_code}</div>
                        <div className={clsx('col-2', styles.participantsTD)}>
                            {participant.role === 'student' ? 'Student' : ''}
                        </div>
                        <div className={clsx('col-3', styles.participantsTD)}></div>
                    </div>
                );
            })}
            <div className={clsx(styles.footer)}>
                {/*<div className={clsx(styles.page)} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {limit} / page
                    <span className="ps-3">
                        <FontAwesomeIcon icon={faCaretDown} />
                    </span>
                </div>
                <ul className={clsx('dropdown-menu', styles.participantDropdown)}>
                    {limits.map((lim) => {
                        if (lim === limit) {
                            return (
                                <li
                                    className={clsx(
                                        'd-flex',
                                        'align-items-center',
                                        'justify-content-between',
                                        'dropdown-item',
                                        styles.participantDropdownItem,
                                    )}
                                    onClick={() => {
                                        handleChangeLimit(lim);
                                    }}
                                >
                                    {lim}
                                    <span>
                                        <FontAwesomeIcon icon={faCheck} />
                                    </span>
                                </li>
                            );
                        } else
                            return (
                                <li
                                    className="dropdown-item"
                                    onClick={() => {
                                        handleChangeLimit(lim);
                                    }}
                                >
                                    {lim}
                                </li>
                            );
                    })}
                </ul>*/}
                <ReactPaginate
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    // previousClassName="page-previous"
                    activeClassName={'active'}
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    pageCount={paginateInfo.pageCount}
                    previousLabel="<"
                    forcePage={page - 1}
                    renderOnZeroPageCount={null}
                />
            </div>
        </div>
    );
};

export default ParticipantsTable;
